import { createContext, useContext, ReactNode } from "react";
import { ChatSettingsType, RecommendedPrompt } from "./types";
import { useRequestSettings } from "./hooks/use-request-settings";

interface SettingsContextType {
  chatSettings: ChatSettingsType;
  setChatSettings: React.Dispatch<React.SetStateAction<ChatSettingsType>>;
  recommendedPrompts: RecommendedPrompt[];
}

const SettingsContext = createContext<SettingsContextType | null>(null);

export const SettingsProvider = ({ children }: { children: ReactNode }) => {
  const { chatSettings, setChatSettings, recommendedPrompts } =
    useRequestSettings();

  return (
    <SettingsContext.Provider
      value={{ chatSettings, setChatSettings, recommendedPrompts }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

// Custom hook to consume context safely
export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error("useSettings must be used within a SettingsProvider");
  }
  return context;
};
